// extracted by mini-css-extract-plugin
export default {"footerLink":"AppContainerFooter_footerLink__ytgDG"};